const bioStandardContent = Object.freeze([
  {
    blockId: 4,
    size: {
      w: 1,
      h: 1
    },
    position: {
      y: 1,
      x: 1
    },
    content_type: 'asset',
    asset_type: 'photo',
    isTileCreator: true,
    blockSubtype: 'image',
    blockType: 'content',
    description: 'Add Image',
    tile_caption: '<p><strong>Jenny Smith</strong></p><p>Managerial manager</p>',
    tile_action_data: {
      type: 'overlay'
    },
    tile_inner_zf_image: {
      cropData: {
        borderRadius: 0
      }
    },
    alt_text: 'Standard image'
  },
  {
    blockId: 5,
    size: {
      w: 1,
      h: 1
    },
    position: {
      y: 1,
      x: 2
    },
    content_type: 'asset',
    asset_type: 'photo',
    isTileCreator: true,
    blockSubtype: 'image',
    blockType: 'content',
    description: 'Add Image',
    tile_caption: '<p><strong>Jenny Smith</strong></p><p>Managerial manager</p>',
    tile_action_data: {
      type: 'overlay'
    },
    tile_inner_zf_image: {
      cropData: {
        borderRadius: 0
      }
    },
    alt_text: 'Standard image'
  },
  {
    blockId: 6,
    size: {
      w: 1,
      h: 1
    },
    position: {
      y: 1,
      x: 3
    },
    content_type: 'asset',
    asset_type: 'photo',
    isTileCreator: true,
    blockSubtype: 'image',
    blockType: 'content',
    description: 'Add Image',
    tile_caption: '<p><strong>Jenny Smith</strong></p><p>Managerial manager</p>',
    tile_action_data: {
      type: 'overlay'
    },
    tile_inner_zf_image: {
      cropData: {
        borderRadius: 0
      }
    },
    alt_text: 'Standard image'
  },
]);

export default bioStandardContent;